<template>
  <div class="settings">
    <div class="row">
      <div class="col-md-offset-4 col-md-4 col-md-offset-4">
        <div v-if="!hasBookieId">
          <form
            action=""
            @submit.prevent="saveBookie()"
          >
            <div class="text-center">
              <h3 style="margin-bottom: 20px;">
                Setup Bookie
              </h3>
            </div>

            <div class="form-group">
              <label for="bookieId">Bookie ID</label>
              <input
                v-model="bookieId"
                type="text"
                class="form-control"
                required
              >
            </div>

            <button
              class="btn btn-primary"
              type="submit"
            >
              Save
            </button>
          </form>
        </div>

        <div
          v-if="hasBookieId"
          class="text-center"
        >
          <h3 style="margin-bottom: 20px;">
            Choose Screen
          </h3>

          <div
            v-for="screen in screens"
            :key="screen.id"
            style="float:left;"
          >
            <div class="screen-button text-center">
              <button
                class="btn btn-success btn-lg"
                style="margin-right: 10px;"
                type="button"
                @click="saveScreen(screen.screenName)"
              >
                {{ screen.screenName }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'Settings',
  data() {
    return {
      bookieId: '',
      screenName: '',
      hasBookieId: false
    };
  },
  computed: {
    screens() {
      return this.$store.getters.screens;
    }
  },
  created() {
    if (localStorage.getItem('bookieId')) {
      this.hasBookieId = true;

      this.getScreens();
    }
  },
  methods: {
    saveBookie() {
      localStorage.setItem('bookieId', this.bookieId);

      this.hasBookieId = true;

      this.getScreens();
    },
    saveScreen(screenName) {
      this.screenName = screenName;

      sessionStorage.setItem('screenName', screenName);

      window.location.href = '/#/?bookieId=' + this.bookieId + '&screenName=' + this.screenName;

      window.location.reload();
    },
    getScreens() {
      const url = `${this.$store.state.betManagerApiUrl}/screen/?populate=&where={"bookie":"${localStorage.getItem('bookieId')}"}`;

      axios.get(url, {
        headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
      })
        .then(response => {
          this.$store.commit('updateScreens', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
.settings{
    margin-top: 40px;
}
.screen-button {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// Settings.vue?5b5dae7f